import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import owlLogo from '../Assets/logo icon transparent background.png';
import Navigation from '../components/shared/Navigation';

const HomePage = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Animation for text changing
    const words = ["Owl", "Intelligence", "Chat"];
    const elements = document.querySelectorAll('.changing-text');
    let currentIndex = 0;
    
    function rotateText() {
      // Hide current text
      elements[currentIndex].classList.remove('visible');
      
      setTimeout(() => {
        currentIndex = (currentIndex + 1) % elements.length;
        elements[currentIndex].classList.add('visible');
      }, 500);
    }
    
    const interval = setInterval(rotateText, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleTryFree = () => {
    navigate('/login'); // Change this from '/' to '/login'
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navigation />
      <div className="pt-20">
        <div className="container mx-auto px-4">
          {/* Hero Section - Updated layout */}
          <section className="flex flex-col md:flex-row items-center justify-between py-16 min-h-[80vh] md:pl-16">
            <div className="md:w-1/2 text-center md:text-left md:pr-12">
              <div className="mb-8">
                <h1 className="text-4xl md:text-6xl font-bold flex items-center">
                  <span className="text-[#1d2840]">Super</span>
                  <div className="relative h-[60px] md:h-[80px] inline-flex items-center ml-2">
                    <span className="changing-text visible absolute text-[#3DA3DC]">Owl</span>
                    <span className="changing-text absolute text-[#3DA3DC]">Intelligence</span>
                    <span className="changing-text absolute text-[#3DA3DC]">Chat</span>
                  </div>
                </h1>
                <div className="flex items-center justify-center md:justify-start mt-4 text-2xl">
                  <span className="text-[#3DA3DC]">Conversational</span>
                  <span className="text-[#1d2840] mx-2">AI</span>
                  <span className="text-[#3DA3DC]">Chat</span>
                </div>
              </div>
              <p className="text-gray-600 text-lg mb-8 max-w-xl">
                SuperOwl is an AI-powered conversational assistant designed specifically for businesses. 
                Enhance customer interactions, automate responses, and improve engagement with our intelligent chat solution.
              </p>
              <div className="flex flex-col items-center md:items-start space-y-4">
                <a href="#" className="text-gray-600 hover:text-[#3DA3DC] transition-colors">
                  Speak to our team today :)
                </a>
                <button
                  onClick={handleTryFree}
                  className="flex items-center px-8 py-3 bg-gradient-to-r from-[#1d2840] to-[#3DA3DC] text-white rounded-full
                            hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
                >
                  Try SuperOwl Free
                  <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </button>
                <div className="mt-2 text-sm text-gray-500 italic">
                  Now in Beta! Join our program and share your feedback.
                </div>
              </div>
            </div>


            {/* Updated logo container with smaller circle */}
            <div className="md:w-1/2 mt-12 md:mt-0 md:flex md:justify-end">
              <div className="relative w-[260px] h-[260px] md:w-[340px] md:h-[340px] mx-auto">
                <div className="absolute inset-0 bg-white rounded-full shadow-lg flex items-center justify-center">
                  <img 
                    src={owlLogo} 
                    alt="SuperOwl Logo" 
                    className="w-[180px] h-[180px] md:w-[240px] md:h-[240px] object-contain"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Footer */}
          <footer className="border-t border-gray-200 py-8 mt-16">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex flex-wrap justify-center gap-6 mb-6 md:mb-0">
                <Link to="/terms" className="text-gray-600 hover:text-[#3DA3DC] text-sm">Terms and Conditions</Link>
                <Link to="/privacy" className="text-gray-600 hover:text-[#3DA3DC] text-sm">Privacy Policy</Link>
                <Link to="/contact" className="text-gray-600 hover:text-[#3DA3DC] text-sm">Contact Us</Link>
              </div>
              <div className="flex gap-4">
                {/* Social Icons */}
                {['facebook', 'twitter', 'linkedin'].map((social) => (
                  <a key={social} href="#" className="text-gray-600 hover:text-[#3DA3DC]">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                            d={social === 'facebook' ? "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" :
                               social === 'twitter' ? "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" :
                               "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z M2 9h4v12H2z M4 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"} />
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </footer>
        </div>

        {/* CSS for animations */}
        <style jsx>{`
          .changing-text {
            opacity: 0;
            transform: translateY(10px);
            transition: all 0.5s ease;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
          }
          
          .changing-text.visible {
            opacity: 1;
            transform: translateY(-50%);
          }

          @media (max-width: 768px) {
            .changing-text {
              font-size: 2.25rem;  /* text-4xl */
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default HomePage;
